import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ListPretsResponse } from '../../interfaces/pret-recouvrement.interface';
import { PretRecouvrementService } from '../../services/pret-recouvrement.service';

/** La page vit dans l'URL : un retour sur la liste retrouve la même page. */
export const listCreditResolver: ResolveFn<ListPretsResponse> = (route: ActivatedRouteSnapshot) => {
  const page = Number(route.queryParamMap.get('page')) || 1;
  return inject(PretRecouvrementService).getPrets(10, page);
};
